import {StyledAccessibility, StyledAccessibilityButton, StyledAccessibilityButtonContainer} from "./styled";
import {AccessibilityWindow} from "./accessibilityWindow";
import {useState} from "react";

export interface AccessibilityProps {}

export const Accessibility: React.FC<AccessibilityProps> = () => {
    const [visible, setVisible] = useState(false);

    const toggleWindow = () => {
        setVisible(!visible);
    };

    return (
        <>
            <StyledAccessibility>
                <StyledAccessibilityButtonContainer>
                    <StyledAccessibilityButton onClick={toggleWindow}/>
                    {visible && <AccessibilityWindow onClose={toggleWindow}/>}
                </StyledAccessibilityButtonContainer>
            </StyledAccessibility>
        </>
    );
}